export type TratamientosControlRepeatableEditRow = {
    producto: string;
    uso: string;
    plaga: string;
    dosisCuaderno: string;
    udCuaderno: string;
    dosis: string;
    udReal: string;
};

export type TratamientosControlRepeatableEditPatch = Record<string, unknown> & {
    lineas_materias: TratamientosControlRepeatableEditRow[];
};

const CONTROL_SLOTS = [1, 2, 3] as const;

/**
 * Converts legacy treatment slot fields into the canonical repeatable FormArray shape.
 * The hidden legacy aggregate controls are still emitted for backwards compatibility.
 */
export class TratamientosControlRepeatableEditState {
    public static buildRows(raw: Record<string, unknown>): TratamientosControlRepeatableEditRow[] {
        return CONTROL_SLOTS.map((slot) => ({
            producto: this.readProduct(raw, slot),
            uso: this.readString(raw, `uso${slot}`),
            plaga: this.readString(raw, `plaga${slot}`),
            dosisCuaderno: this.readString(raw, `dosis_cuaderno${slot}`),
            udCuaderno: this.readString(raw, `ud_cuaderno_${slot}`),
            dosis: this.readString(raw, `dosis${slot}`),
            udReal: this.readString(raw, `ud_real_${slot}`),
        }));
    }

    public static buildPatch(raw: Record<string, unknown>): TratamientosControlRepeatableEditPatch {
        const rows = this.buildRows(raw);

        return {
            lineas_materias: rows,
            _linea_producto: this.join(rows, 'producto'),
            _linea_uso: this.join(rows, 'uso'),
            _linea_plaga: this.join(rows, 'plaga'),
            _linea_dosis_cuaderno: this.join(rows, 'dosisCuaderno'),
            _linea_ud_cuaderno: this.join(rows, 'udCuaderno'),
            _linea_dosis: this.join(rows, 'dosis'),
            _linea_ud_real: this.join(rows, 'udReal'),
        };
    }

    public static hasActiveRows(rows: readonly TratamientosControlRepeatableEditRow[]): boolean {
        return rows.some((row) => row.producto !== '');
    }

    private static readProduct(raw: Record<string, unknown>, slot: 1 | 2 | 3): string {
        const value = raw[`id_producto${slot}`];
        const normalizedValue = this.readUnknown(value);

        return normalizedValue !== '0' ? normalizedValue : '';
    }

    private static readString(raw: Record<string, unknown>, key: string): string {
        return this.readUnknown(raw[key]);
    }

    private static readUnknown(value: unknown): string {
        if (value === null || value === undefined) {
            return '';
        }

        const normalizedValue = String(value).trim();
        const lowerValue = normalizedValue.toLowerCase();

        return normalizedValue !== '' && lowerValue !== 'null' && lowerValue !== 'undefined' && lowerValue !== 'nan'
            ? normalizedValue
            : '';
    }

    private static join(
        rows: readonly TratamientosControlRepeatableEditRow[],
        key: keyof TratamientosControlRepeatableEditRow,
    ): string {
        return rows.map((row) => row[key]).join(';');
    }
}
